import React, { useState } from 'react';
import styles from './AnteProyectosValidationSection.module.scss';
import AnteProyectoCard from './AnteProyectoCard.tsx';
import AnteProyectoDetailModal from './AnteProyectoDetailModal.tsx';
import Pagination from '../Shared/Pagination.tsx';
import EmptyState from '../Shared/EmptyState.tsx';
import LoadingSpinner from '../Shared/LoadingSpinner.tsx';
import FilterBar from './FilterBar.tsx';
import { AnteProyectoValidation, BackofficeFilters } from '../../../../types/backoffice.ts';

interface AnteProyectosValidationSectionProps {
  anteProyectos: AnteProyectoValidation[];
  loading: boolean;
  currentPage: number;
  totalPages: number;
  filters: BackofficeFilters;
  onPageChange: (page: number) => void;
  onFilterChange: (filters: Partial<BackofficeFilters>) => void;
  onValidate: (id: string, isApproved: boolean, reason?: string, adminNote?: string) => void;
  validationLoading: boolean;
}

const AnteProyectosValidationSection: React.FC<AnteProyectosValidationSectionProps> = ({
  anteProyectos,
  loading,
  currentPage,
  totalPages,
  filters,
  onPageChange,
  onFilterChange,
  onValidate,
  validationLoading
}) => {
  const [selectedProyecto, setSelectedProyecto] = useState<AnteProyectoValidation | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = (proyecto: AnteProyectoValidation) => {
    setSelectedProyecto(proyecto);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedProyecto(null);
  };

  const handleValidate = (id: string, isApproved: boolean, reason?: string, adminNote?: string) => {
    onValidate(id, isApproved, reason, adminNote);
    closeModal();
  };

  if (loading) {
    return <LoadingSpinner message="Cargando ante proyectos..." />;
  }

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <div>
          <h2 className={styles.title}>Validación de Ante Proyectos</h2>
          <p className={styles.subtitle}>
            Revisa y aprueba los proyectos antes de publicarlos
          </p>
        </div>
        <span className={styles.count}>
          {anteProyectos.length} {anteProyectos.length === 1 ? 'proyecto' : 'proyectos'}
        </span>
      </div>

      <FilterBar
        filters={filters}
        onFilterChange={onFilterChange}
      />

      {anteProyectos.length === 0 ? (
        <EmptyState
          title="No hay proyectos para validar"
          message="Todos los proyectos han sido procesados o no hay proyectos que coincidan con los filtros"
        />
      ) : (
        <>
          <div className={styles.grid}>
            {anteProyectos.map((proyecto) => (
              <AnteProyectoCard
                key={proyecto.id}
                proyecto={proyecto}
                onViewDetails={openModal}
                onValidate={handleValidate}
                validationLoading={validationLoading}
              />
            ))}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            disabled={loading}
          />
        </>
      )}

      {modalOpen && selectedProyecto && (
        <AnteProyectoDetailModal
          proyecto={selectedProyecto}
          onClose={closeModal}
          onValidate={handleValidate}
          validationLoading={validationLoading}
        />
      )}
    </div>
  );
};

export default AnteProyectosValidationSection;

